module.exports = __webpack_public_path__ + "static/media/blogImg2.2da4631c.png";